import React from 'react';

import GenericTile from '@atlaskit/tile/tile';

import { LoomVideoGlyph } from '../../../../../../common/ui/icon-for-3p/loom-video-glyph';

export const LoomVideoIcon = (): React.JSX.Element => (
	<GenericTile label="" size="medium" testId="loom-video-icon">
		<LoomVideoGlyph />
	</GenericTile>
);
